import { useState } from 'react';
import { toast } from 'sonner';
import { UNITS, SECTORS, factoryCatalog, secOf, saveCatalog } from '../lib/catalog';

const num = (v) => (v === '' ? null : Number.isFinite(+v) ? +v : null);

// load the factory template of a sector (missing items restored, own prices kept)
export function TemplateLoader({ t, cat }) {
  const [sec, setSec] = useState(SECTORS.includes(cat.sector) ? cat.sector : 'water');
  const load = () => {
    const have = new Set(cat.items.map((x) => x.id)), add = factoryCatalog().filter((x) => secOf(x) === sec && !have.has(x.id));
    saveCatalog({ ...cat, sector: sec, items: [...cat.items, ...add] });
    toast.success(`${t.ctLoaded}: ${t['sec_' + sec]} (+${add.length})`);
  };
  return (
    <div className="row cat-tpl" data-testid="catalog-template">
      <b>📋 {t.ctTitle}</b>
      <select data-testid="catalog-template-select" value={sec} onChange={(e) => setSec(e.target.value)}>{SECTORS.map((s) => <option key={s} value={s}>{t['sec_' + s]}</option>)}</select>
      <button className="btn btn-dark btn-sm" data-testid="catalog-template-load" onClick={load}>{t.ctLoad}</button>
    </div>
  );
}

// keyboard-friendly bulk edit table (Tab / Shift+Tab / Enter = next row)
export default function CatalogTable({ t, list, items, save }) {
  const set = (id, p) => save(items.map((x) => (x.id === id ? { ...x, ...p } : x)));
  const next = (e) => { if (e.key !== 'Enter') return; e.preventDefault(); const { r, c } = e.target.dataset, el = document.querySelector(`[data-r="${+r + 1}"][data-c="${c}"]`); el?.focus(); el?.select?.(); };
  const cell = (x, i, k, c, type = 'text') => <input data-r={i} data-c={c} data-testid={`catalog-table-${k}-${x.id}`} inputMode={type === 'num' ? 'decimal' : undefined} defaultValue={x[k] ?? ''} onKeyDown={next} onBlur={(e) => { const v = type === 'num' ? num(e.target.value.replace(',', '.')) : e.target.value; if (v !== (x[k] ?? (type === 'num' ? null : ''))) set(x.id, { [k]: v }); }} />;
  return (
    <div className="cat-table-wrap" data-testid="catalog-table">
      <table className="cat-table">
        <thead><tr><th>{t.catName}</th><th>{t.catDim}</th><th>{t.catSku}</th><th>{t.colUnit}</th><th>{t.catPrice}</th><th>{t.catInstall}</th></tr></thead>
        <tbody>
          {list.map((x, i) => (
            <tr key={x.id} data-testid={`catalog-table-row-${x.id}`}>
              <td>{cell(x, i, 'name', 0)}</td><td>{cell(x, i, 'dim', 1)}</td><td>{cell(x, i, 'sku', 2)}</td>
              <td><select data-r={i} data-c={3} data-testid={`catalog-table-unit-${x.id}`} value={x.unit} onChange={(e) => set(x.id, { unit: e.target.value })}>{UNITS.map((u) => <option key={u} value={u}>{t['unit_' + u]}</option>)}</select></td>
              <td>{cell(x, i, 'price', 4, 'num')}</td><td>{cell(x, i, 'install', 5, 'num')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
